export const download = (blob, name) => {
  const link = document.createElement('a');
  try {
    if (blob instanceof Blob) {
      link.href = window.URL.createObjectURL(blob);
    } else if (typeof blob === "string") {
      link.href = blob;
    }
    link.setAttribute("download", name);
    document.body.appendChild(link);
    link.click();
    setTimeout(() => {
      document.body.removeChild(link);
    }, 500);
  } catch (e) {
    console.log(e);
  }
};
